export default {
  // Page title and subtitle
  'page.mainTitle': 'Discord Timestamp Generator',
  'page.mainTitleSEO': 'Discord Timestamp Generator - Create Dynamic <t:format> Codes',
  'page.subtitle': 'Generate Discord timestamps with automatic timezone conversion for everyone',

  // Generator tool section
  'page.generatorTitle': 'Interactive Discord Timestamp Generator',
  'page.selectDateTime': 'Select Date & Time:',
  'page.chooseFormat': 'Choose Display Format:',
  'page.generatedCode': 'Generated Discord Code:',
  'page.preview': 'Preview in Discord:',
  'page.copyCode': 'Copy Code',

  // Format options
  'page.format.t': 'Short Time',
  'page.format.t.example': '4:30 PM',
  'page.format.t.desc': 'Displays time only, short format',

  'page.format.T': 'Long Time',
  'page.format.T.example': '4:30:00 PM',
  'page.format.T.desc': 'Displays time only, with seconds',

  'page.format.d': 'Short Date',
  'page.format.d.example': '12/31/2024',
  'page.format.d.desc': 'Displays date only, short format',

  'page.format.D': 'Long Date',
  'page.format.D.example': 'December 31, 2024',
  'page.format.D.desc': 'Displays full date',

  'page.format.f': 'Short Date/Time',
  'page.format.f.example': 'December 31, 2024 4:30 PM',
  'page.format.f.desc': 'Most commonly used format',

  'page.format.F': 'Long Date/Time',
  'page.format.F.example': 'Tuesday, December 31, 2024 4:30 PM',
  'page.format.F.desc': 'Full date and time with day of week',

  'page.format.R': 'Relative Time',
  'page.format.R.example': '2 hours ago / in 3 days',
  'page.format.R.desc': 'Dynamic countdown or time elapsed',

  // Format reference table
  'page.formatReference': 'Discord Timestamp Format Reference',
  'page.formatCode': 'Format Code',
  'page.style': 'Style',
  'page.exampleOutput': 'Example Output',
  'page.useCase': 'Use Case',

  'page.useCase.t': 'Event start times',
  'page.useCase.T': 'Precise timing',
  'page.useCase.d': 'Compact date display',
  'page.useCase.D': 'Full date display',
  'page.useCase.f': 'General purpose',
  'page.useCase.F': 'Formal announcements',
  'page.useCase.R': 'Countdowns, time since events',

  // How to use section
  'page.howToUse': 'How to Use Discord Timestamps',
  'page.step1': 'Generate your timestamp code',
  'page.step1Desc': 'Use the tool above to select a date/time and format',

  'page.step2': 'Copy the generated code',
  'page.step2Desc': 'Example: <t:1735689000:F>',

  'page.step3': 'Paste into any Discord message',
  'page.step3Desc': 'Works in text channels, DMs, threads, and forum posts',

  'page.step4': 'Everyone sees it in their timezone!',
  'page.step4Desc': 'Discord automatically converts to each user\'s local time',

  // FAQ section
  'page.faq': 'Discord Timestamp FAQ',

  'page.faq.q1': 'What is a Discord timestamp?',
  'page.faq.a1': 'Discord timestamps use Unix epoch time with special format codes (<t:timestamp:format>) to display dynamic times that automatically adjust to each user\'s local timezone.',

  'page.faq.q2': 'Why use Discord timestamps instead of typing the time?',
  'page.faq.a2': 'Discord timestamps automatically convert to each user\'s local timezone, so everyone sees the correct time for their location. This eliminates confusion when coordinating events across time zones.',

  'page.faq.q3': 'Which format should I use?',
  'page.faq.a3': 'Use <t:timestamp:R> for countdowns and events, <t:timestamp:F> for formal announcements, and <t:timestamp:f> for general purposes.',

  'page.faq.q4': 'Do Discord timestamps work in all channels?',
  'page.faq.a4': 'Yes! Discord timestamps work in text channels, DMs, threads, forum posts, and even in channel topics.',

  'page.faq.q5': 'Can I use Discord timestamps in embeds?',
  'page.faq.a5': 'Yes, Discord timestamps work in embed descriptions and field values when using Discord bots.',

  'page.faq.q6': 'What happens if I use an invalid timestamp?',
  'page.faq.a6': 'Discord will display the raw code without converting it. Make sure to use valid Unix timestamps.',

  // Related tools section
  'page.relatedTools': 'Related Timestamp Tools',
  'page.needUnixTimestamp': 'Need a Unix Timestamp?',
  'page.needUnixTimestampDesc': 'Use our Unix Timestamp Converter to convert any date to epoch time.',
  'page.checkYouTubeTool': 'Or check out YouTube Timestamp Creator',

  // Common use cases
  'page.commonUseCases': 'Common Use Cases',
  'page.useCase1.title': 'Event Scheduling',
  'page.useCase1.desc': 'Announce game nights, movie watch parties, or community events',

  'page.useCase2.title': 'Raid Timers',
  'page.useCase2.desc': 'Coordinate gaming sessions across different time zones',

  'page.useCase3.title': 'Release Countdowns',
  'page.useCase3.desc': 'Create excitement for game launches, album drops, or updates',

  'page.useCase4.title': 'Meeting Reminders',
  'page.useCase4.desc': 'Schedule team meetings in community servers',

  'page.useCase5.title': 'Contest Deadlines',
  'page.useCase5.desc': 'Set clear deadlines for giveaways and competitions',

  'page.useCase6.title': 'Server Events',
  'page.useCase6.desc': 'Track anniversaries, milestones, and special occasions',
};
